/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ESickNoteNpCareCaseClosureSchema } from '../models/ESickNoteNpCareCaseClosureSchema';
import type { ESickNoteNpCareCaseCreateSchema } from '../models/ESickNoteNpCareCaseCreateSchema';
import type { ESickNoteNpCareCaseDetailSchema } from '../models/ESickNoteNpCareCaseDetailSchema';
import type { ESickNoteNpCaseDurationConfirmationSchema } from '../models/ESickNoteNpCaseDurationConfirmationSchema';
import type { ESickNoteNpCaseReportSchema } from '../models/ESickNoteNpCaseReportSchema';
import type { ESickNoteSubmissionDetailSchema } from '../models/ESickNoteSubmissionDetailSchema';
import type { PagedESickNoteNpCareCaseDetailSchema } from '../models/PagedESickNoteNpCareCaseDetailSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EsickNotesNpCareApi {
    /**
     * Create Esick Note Np Care Case
     * Issue an ošetřovné decision and submit it to ČSSZ (ČSSZ Rpop1, or Rpop2 when careUntil is given). Required Permission: create_esick_note
     * @returns ESickNoteNpCareCaseDetailSchema Created
     * @throws ApiError
     */
    public static esickNoteNpCareCreateEsickNoteNpCareCasePost({
        requestBody,
    }: {
        requestBody: ESickNoteNpCareCaseCreateSchema,
    }): CancelablePromise<ESickNoteNpCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/esick-notes/np/care/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Esick Note Np Care Case List
     * List ošetřovné cases of the logged-in user's company. Required Permission: create_esick_note
     * @returns PagedESickNoteNpCareCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpCareGetEsickNoteNpCareCaseListGet({
        patientId,
        open,
        needsDurationConfirmation,
        limit = 100,
        offset,
    }: {
        patientId?: (string | null),
        open?: (boolean | null),
        /**
         * Open cases whose need for care has not been confirmed to ČSSZ for 25 days or more.
         */
        needsDurationConfirmation?: (boolean | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedESickNoteNpCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/np/care/',
            query: {
                'patient_id': patientId,
                'open': open,
                'needs_duration_confirmation': needsDurationConfirmation,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Create Esick Note Np Care Case Report
     * Submit an attending doctor's report on care: handing the case over or a hospitalization (ČSSZ HolNp). The report is stored with the submission history and reflected in the case's current state, which is returned. Required Permission: create_esick_note
     * @returns ESickNoteNpCareCaseDetailSchema Created
     * @throws ApiError
     */
    public static esickNoteNpCareCreateEsickNoteNpCareCaseReportPost({
        npCaseId,
        requestBody,
    }: {
        npCaseId: string,
        requestBody: ESickNoteNpCaseReportSchema,
    }): CancelablePromise<ESickNoteNpCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/esick-notes/np/care/{np_case_id}/reports/',
            path: {
                'np_case_id': npCaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get Esick Note Np Care Case
     * Ošetřovné case detail. Required Permission: create_esick_note
     * @returns ESickNoteNpCareCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpCareGetEsickNoteNpCareCaseGet({
        npCaseId,
    }: {
        npCaseId: string,
    }): CancelablePromise<ESickNoteNpCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/np/care/{np_case_id}/',
            path: {
                'np_case_id': npCaseId,
            },
        });
    }
    /**
     * Get Esick Note Np Care Case Submission List
     * List every podání ČSSZ accepted for this ošetřovné case, newest first, with what was sent. Required Permission: create_esick_note
     * @returns ESickNoteSubmissionDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpCareGetEsickNoteNpCareCaseSubmissionListGet({
        npCaseId,
    }: {
        npCaseId: string,
    }): CancelablePromise<Array<ESickNoteSubmissionDetailSchema>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/esick-notes/np/care/{np_case_id}/submissions/',
            path: {
                'np_case_id': npCaseId,
            },
        });
    }
    /**
     * Set Esick Note Np Care Case Closure
     * End the need for care and report it to ČSSZ (ČSSZ Rpop2). Required Permission: create_esick_note
     * @returns ESickNoteNpCareCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpCareSetEsickNoteNpCareCaseClosurePut({
        npCaseId,
        requestBody,
    }: {
        npCaseId: string,
        requestBody: ESickNoteNpCareCaseClosureSchema,
    }): CancelablePromise<ESickNoteNpCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/esick-notes/np/care/{np_case_id}/closure/',
            path: {
                'np_case_id': npCaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Set Esick Note Np Care Case Duration Confirmation
     * Confirm to ČSSZ that the need for care continues; required at least monthly (ČSSZ PtNp). Required Permission: create_esick_note
     * @returns ESickNoteNpCareCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpCareSetEsickNoteNpCareCaseDurationConfirmationPut({
        npCaseId,
        requestBody,
    }: {
        npCaseId: string,
        requestBody: ESickNoteNpCaseDurationConfirmationSchema,
    }): CancelablePromise<ESickNoteNpCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/esick-notes/np/care/{np_case_id}/duration-confirmation/',
            path: {
                'np_case_id': npCaseId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Sync Esick Note Np Care Case From Cssz
     * Read the case back from ČSSZ now and update its state, end, start, diagnosis and takeover (ČSSZ IkreNpVratDetailPripadu); the same runs daily for every open case. Required Permission: create_esick_note
     * @returns ESickNoteNpCareCaseDetailSchema OK
     * @throws ApiError
     */
    public static esickNoteNpCareSyncEsickNoteNpCareCaseFromCsszPost({
        npCaseId,
    }: {
        npCaseId: string,
    }): CancelablePromise<ESickNoteNpCareCaseDetailSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/esick-notes/np/care/{np_case_id}/cssz-sync/',
            path: {
                'np_case_id': npCaseId,
            },
        });
    }
}
